import React from "react";
import { fmtInt } from "./sandbox/resumenData";

export interface FilterOption<T extends string> {
  id: T;
  label: string;
  count: number;
}

interface Props<T extends string> {
  label: string;
  value: T;
  defaultId: T;
  options: FilterOption<T>[];
  onChange: (id: T) => void;
  testId?: string;
}

/** Filtro de escritorio: etiqueta y select nativo con el mismo estilo que el selector de período del header. */
export function SocialFilterSelect<T extends string>({ label, value, defaultId, options, onChange, testId }: Props<T>) {
  return (
    <label className="sbx-chip-select" data-active={value !== defaultId || undefined}>
      <span>{label}</span>
      <select className="compact-select" value={value} data-testid={testId} onChange={(e) => onChange(e.target.value as T)}>
        {options.map((o) => (
          <option key={o.id} value={o.id}>
            {o.label} · {fmtInt(o.count)}
          </option>
        ))}
      </select>
    </label>
  );
}
